module.exports = __webpack_public_path__ + "img/zw.76db6ed5.svg";